:global(.email-settings-page) .email-templates-page-header {
    margin-top: -16px;
}
